import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProfileViewModel } from 'src/app/data/api/models';
import { NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: "szz-header",
    templateUrl: "./header.component.html",
    styleUrl: "./header.component.scss",
    imports: [NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem]
})
export class HeaderComponent {
  @Input() model!: ProfileViewModel;
  @Output() logout = new EventEmitter<void>();
  @Output() toggleSidebar = new EventEmitter<void>();

  onLogout() {
    this.logout.emit();
  }
}
